import React, { useEffect, useState } from "react";
import { ApiService } from "../../components/Common/ApiService";
import { isIdTarget, isPending } from "../../store/actions/todoActions";
import CryptoJS from "crypto-js";

import { useDispatch } from "react-redux";
import Button from "../../components/Common/Button";
import { formatRupiah, useHandleClickLoading } from "../../components/Common/utils";

import { ReactComponent as Logolight } from "../../assets/logo_light.svg";
import CopyToClipboard from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import { ReactComponent as SearchIcon } from "../../assets/icon/ri_search-line.svg";
import { ReactComponent as DefenderIcon } from "../../assets/icon/DSADD 1.svg";
import { ReactComponent as MoneyIcon } from "../../assets/icon/money.svg";
import ConditionalRender from "../../components/Common/ConditionalRender";
import Input from "../../components/Common/Input";
import ModalBox from "../../components/Common/ModalBox";
import PaymentMethodComponent from "../product/PaymentMethodComponent";
import ModalOrderConfirm from "../product/ModalOrderConfirm";

function GiftCard() {
    const isLogin = localStorage.getItem("isLogin");
    const parseLogin = JSON.parse(isLogin);
    const isProfile = localStorage.getItem("isProfile");
    const profileData = JSON.parse(isProfile);
    const [paymentData, setPaymentData] = useState([]);
    const [listMemberData, setListMemberData] = useState([]);


    const [paymentLoading, setPaymentLoading] = useState(true);
    const [listMemberLoading, setListMemberLoading] = useState(true);

    const [selectedrekPayment, setselectedrekPayment] = useState([]);
    const [selectedPaymentItems, setSelectedPaymentItems] = useState([]);
    const [orderConfirm, setOrderConfirm] = useState([]);
    const [inputSaldo, setInputSaldo] = useState(0);
    const [invoice, setInvoice] = useState(0);
    const [confirmModal, setconfirmModal] = useState(false);
    const [reedemVoucher, setreedemVoucher] = useState("");
    const [expired, setExpired] = useState("");

    const [itemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const [poin, setPoint] = useState(0);

    const [selectedNominalItems, setselectedNominalItems] = useState({
        kategori: 'Saldo',
        harga: '0'
    });
    const [hargaFix, setHargaFix] = useState({ harga: 0, logo: "" });
    const [isModalOrderConfirm, setIsModalOrderConfirm] = useState(false);
    const [isModalSuccessTransaction, setIsModalSuccessTransaction] = useState(false);

    const dispatch = useDispatch();
    const handleClickLoading = useHandleClickLoading();

    useEffect(() => {
        if (isLogin) {
            fetchListgiftCard(parseLogin?.apiKey, parseLogin?.token);
            fetchPoin(parseLogin?.apiKey, parseLogin?.token);
        }
        fetchDataPayment();
        dispatch(isIdTarget(undefined));
    }, [dispatch]);


    useEffect(() => {
        if (isLogin) {
            const parseLogin = JSON.parse(isLogin);
            fetchListgiftCard(parseLogin?.apiKey, parseLogin?.token);
        }
    }, [currentPage]);

    const fetchPoin = async (api_key, token) => {
        try {
            const params = new URLSearchParams();
            params.append("api_key", api_key);
            params.append("limit", "10000");
            params.append("page", "1");

            const response = await ApiService({
                baseurl: "user/listTukarPoint",
                parameter: "api_key=" + api_key,
                method: "POST",
                XGORDON: "LISTTUKARPOINT",
                apiKey: api_key,
                token: token,
                body: params,
            });
            if (response?.statusCode === 200) {
                setPoint(response.result.pointku)
            } else {
                setListMemberData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchListgiftCard = async (api_key, token) => {
        setListMemberLoading(true);
        try {
            const params = new URLSearchParams();
            params.append("api_key", api_key);
            params.append("limit", itemsPerPage);
            params.append("page", currentPage);

            const response = await ApiService({
                baseurl: "user/listGiftCard",
                parameter: "api_key=" + api_key,
                method: "POST",
                XGORDON: "LISTGIFTCARD",
                apiKey: api_key,
                token: token,
                body: params,
            });
            setListMemberLoading(false);
            if (response?.statusCode === 200) {
                setListMemberData(response.result.data);
            } else {
                setListMemberData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchDataPayment = async () => {
        setPaymentLoading(true);
        try {
            const response = await ApiService({
                baseurl: "user/pembayaran",
                method: "POST",
                XGORDON: "PEMBAYARAN",
            });
            setPaymentLoading(false);
            if (response?.statusCode === 200) {
                setPaymentData(response.result.data);
            } else {
                setPaymentData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const getOrderConfirm = async () => {
        dispatch(isPending(true));
        const transformedDatalayanan = { id: inputSaldo };
        const transformedDataPayment = { metode: selectedPaymentItems.id };
        const transformedDataKontak = { kontak: profileData?.ponsel };
        const transformedDataphonePayment =
            selectedrekPayment?.length === 0
                ? null
                : selectedrekPayment[0].nama === "Saldo"
                    ? { pintrx: selectedrekPayment[0].value }
                    : { rek: selectedrekPayment[0].value };
        // Menggabungkan semua objek menjadi satu objek tunggal
        const combinedData = {
            ...transformedDatalayanan,
            ...transformedDataPayment,
            ...transformedDataKontak,
            ...transformedDataphonePayment,
        };
        const parsedObject = JSON.parse(isLogin);
        try {
            const params = new URLSearchParams();
            for (const key in combinedData) {
                params.append(key, combinedData[key]);
            }
            params.append("api_key", parsedObject?.apiKey);

            const response = await ApiService({
                baseurl: "user/orderConfirmGiftCard",
                method: "POST",
                XGORDON: "ORDERCONFIRMGIFT",
                body: params,
                apiKey: parsedObject?.apiKey,
                token: parsedObject?.token
            });
            dispatch(isPending(false));
            if (response?.statusCode === 200) {
                setOrderConfirm(response.result.data);
                toggleModalOrderConfirm();
            } else {
                toast.error(response?.result.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setOrderConfirm([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const setOrderFix = async (tokenSHA) => {
        dispatch(isPending(true));
        const transformedDatalayanan = { id: inputSaldo };
        const transformedDataPayment = { metode: selectedPaymentItems.id };
        const transformedDataKontak = { kontak: profileData?.ponsel };
        const transformedDataphonePayment =
            selectedrekPayment?.length === 0
                ? null
                : selectedrekPayment[0].nama === "Saldo"
                    ? { pintrx: selectedrekPayment[0].value }
                    : { rek: selectedrekPayment[0].value };
        // Menggabungkan semua objek menjadi satu objek tunggal
        const combinedData = {
            ...transformedDatalayanan,
            ...transformedDataPayment,
            ...transformedDataKontak,
            ...transformedDataphonePayment,
        };
        const parsedObject = JSON.parse(isLogin);
        try {
            const params = new URLSearchParams();
            for (const key in combinedData) {
                params.append(key, combinedData[key]);
            }
            params.append("api_key", parsedObject?.apiKey);
            params.append("layanan", "giftcard");

            const response = await ApiService({
                baseurl: "user/order",
                method: "POST",
                customHeaders: { "x-gorgon": tokenSHA },
                body: params,
                apiKey: parsedObject?.apiKey,
                token: parsedObject?.token
            });
            dispatch(isPending(false));
            if (response?.statusCode === 200) {
                toggleModalOrderConfirm();
                toggleModalSuccessTransaction();
                setInvoice(response?.result.invoice);
            } else {
                toast.error(response?.result.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const confirmReedemVoucher = async () => {
        dispatch(isPending(true));
        try {
            const params = new URLSearchParams();
            params.append('api_key', parseLogin?.apiKey);
            params.append('giftcard', reedemVoucher);

            const response = await ApiService({
                baseurl: "user/konfirmGiftCard",
                method: "POST",
                XGORDON: "KONFIRMGIFTCARD",
                body: params,
                apiKey: parseLogin?.apiKey,
                token: parseLogin?.token,

            });
            dispatch(isPending(false));
            if (response?.statusCode === 200) {
                setconfirmModal(true)
                setExpired(response?.result.data.expired)
                console.log(response?.result.data.expired);
            } else {
                toast.error(response?.result.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const changeReedemVoucher = async () => {
        dispatch(isPending(true));
        const parsedObject = JSON.parse(isLogin);
        const originalString = `${reedemVoucher}${expired}${parsedObject?.apiKey}`;
        console.log(originalString);
        const sha256Hash = CryptoJS.SHA256(originalString).toString();
        try {
            const params = new URLSearchParams();
            params.append('api_key', parseLogin?.apiKey);
            params.append('voucher_code', reedemVoucher);

            const response = await ApiService({
                baseurl: "user/redeem",
                method: "POST",
                customHeaders: { "x-gorgon": sha256Hash },
                XGORDON: "REDEEM",
                body: params,
                apiKey: parseLogin?.apiKey,
                token: parseLogin?.token,

            });
            dispatch(isPending(false));
            if (response?.statusCode === 200) {
                toast.success(response?.result.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setconfirmModal(false)
            } else {
                toast.error(response?.result.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setconfirmModal(true)
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    const toggleModalOrderConfirm = () => {
        setIsModalOrderConfirm(!isModalOrderConfirm);
    };

    const toggleModalSuccessTransaction = () => {
        setIsModalSuccessTransaction(!isModalSuccessTransaction);
    };
    const handleNextPage = () => {
        setCurrentPage((halamanSebelumnya) => halamanSebelumnya + itemsPerPage);
    };

    const handlePreviousPage = () => {
        if (currentPage > 0) {
            setCurrentPage((halamanSebelumnya) => halamanSebelumnya - itemsPerPage);
        }
    };

    return (
        <div className="flex flex-col gap-3 flex-1">
            <div className="flex flex-row lg:rounded-lg rounded-none shadow-inner overflow-hidden bg-cardLight dark:bg-cardDark sm: min-h-[100px] relative">
                <div className="flex flex-col gap-2 justify-center flex-1 p-3">
                    <span className="text-3xl  text-[#22BDE2] font-bold">Giftcard</span>
                    <span className=" text-base font-light ">Beli giftcard  atau redeem giftcard-mu disini, kamu bisa belikan untuk hadiah ke teman mabarmu!
                    </span>
                    <span className=" text-base font-semibold"> Redeem Giftcard</span>
                    <div className="flex flex-row items-center gap-2">
                        <div className="flex flex-1">
                            <Input
                                id={1}
                                value={reedemVoucher}
                                onChange={(value) => {
                                    const inputValue = value;
                                    setreedemVoucher(inputValue);
                                }}
                                type={"text"}
                                bgcolor={"bg-[#edeeee]"}
                                placeholder={`Masukan kode Giftcard`}
                            />
                        </div>
                        <Button
                            iconLeft={<SearchIcon className="h-5 w-5" />}
                            type="fill"
                            color={'#ffffff'}
                            className={"bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] text-darkColor"}
                            onClick={() => {
                                if (reedemVoucher.length < 4) {
                                    toast.error("Kode GiftCard Kosong", {
                                        position: toast.POSITION.TOP_RIGHT,
                                    });
                                } else {
                                    confirmReedemVoucher();
                                }
                            }}
                        />
                    </div> 
                </div>
                <div className="md:flex hidden flex-1">
                    <img
                        src={require('../../assets/images/pngwing 4.png')}
                        alt="Logo"
                        className="object-cover  object-right flex-1 h-60 " />
                </div>
            </div>
            <div className="flex flex-col rounded-lg shadow-inner bg-cardLight dark:bg-cardDark min-h-[300px]">
                <div className="p-3 pb-2 ">
                    <span className=" text-base font-semibold">   Cara Beli dan Pakai Giftcard</span>
                </div>
                <span className="text-sm opacity-60  px-3">
                    1. Pilih Jumlah Saldo yang ingin dibeli
                </span>
                <span className="text-sm opacity-60  px-3">
                    2. Pilih Metode Pembayaran
                </span>
                <span className="text-sm opacity-60  px-3">
                    3. Selesaikan Pembayaran
                </span>
                <span className="text-sm opacity-60  px-3 pb-3">
                    4. Voucher Giftcard bisa dilihat di halaman Riwayat Transaksi, giftcard bisa dikirim ke email
                </span>

                <div className="p-3 pb-2 border-t ">
                    <span className=" text-base font-semibold">My Giftcard</span>
                </div>
                <ConditionalRender
                    productsData={listMemberData}
                    isLoading={listMemberLoading}
                    model={"emptyData"}
                >
                    <div className="grid grid-cols-1 xl:grid-cols-5 sm:grid-cols-3 gap-2 p-3 ">
                        {listMemberData.map((item, index) => (
                            <CopyToClipboard
                                key={index}
                                text={item.gift_code}
                                onCopy={() => {
                                    //   downloadImage(item.gift_code);
                                    toast.success(item.gift_code + " Tersalin", {
                                        position: toast.POSITION.TOP_RIGHT,
                                    });
                                }}>
                                <div
                                    className={`flex flex-row relative cursor-pointer bg-cardLight shadow-inner rounded-md overflow-clip`}
                                    id={`imagevoucer-${item.gift_code}`}
                                >
                                    <div className="bg-gradient-to-t p-2 from-[#FFB6FF] to-[#B9BDFF]">
                                        <div className="rotate-180 text-2xl text-white font-bold"
                                            style={{ writingMode: 'vertical-rl' }}
                                        >
                                            GIFT CARD
                                        </div>
                                    </div>

                                    <div className="flex flex-col flex-1 justify-between p-3">
                                        <Logolight className="h-10 w-32" />
                                        <div className="flex flex-col gap-1">
                                            <span className="text-md font-bold ">
                                                {item.gift_code}
                                            </span>
                                            <span className="text-base ">
                                                {formatRupiah(item.nominal)}
                                            </span>
                                        </div>
                                    </div>
                                    {/* <img
                                        src={require("../../assets/images/giftlist.png")}
                                        alt={`${item.nominal} logo`}
                                        className="w-full object-cover aspect-[2.5/1] rounded-xl "
                                    />
                                    <div className="absolute  top-3 right-8 bottom-2 left-8  flex flex-col justify-between items-end p-1 rounded-md ">
                                       
                                    </div> */}
                                </div>
                            </CopyToClipboard>
                        ))}
                    </div>
                </ConditionalRender>

                <div className=" flex flex-row justify-center gap-2 pb-3">
                    <Button
                        disabled={currentPage <= 0}
                        initialValue="Sebelumnya"
                        type="fill"
                        className={`border-[#22BDE2] border-2 text-[#22BDE2] dark:border-[#ffffff] h-[40px] dark:text-darkColor  sm:inline-flex rounded-md ${currentPage <= 0 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                        onClick={() => { handlePreviousPage() }}
                    />
                    <Button
                        disabled={listMemberData.length === 0}
                        initialValue="Selanjutnya"
                        type="fill"
                        className={`border-[#22BDE2] border-2 text-[#22BDE2] dark:border-[#ffffff] h-[40px] dark:text-darkColor  sm:inline-flex rounded-md ${listMemberData.length <= 0 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                        onClick={() => handleNextPage()}
                    />
                </div>
            </div>

            <div className="flex sm:flex-row flex-col gap-3 px-3" >
                <div className="flex flex-col gap-3 justify-between flex-1" >
                    <div className="flex flex-col rounded-lg shadow-inner bg-cardLight dark:bg-cardDark " >
                        <div className="flex flex-row items-center gap-1 rounded-md  bg-[#22BDE2] text-darkColor">
                            <div className=' items-center justify-center flex rounded-md bg-gradient-to-r from-[#22BDE2] to-[#FC00FF]  p-3 h-12 w-12 '>
                                <span className="font-bold">
                                    1
                                </span>
                            </div>
                            <span className="text-base px-3 font-medium line-clamp-1">
                                Masukan Jumlah
                            </span>
                        </div>
                        <div className="flex flex-col justify-between rounded-b-lg gap-2 p-3 ">
                            <span className="text-base font-medium line-clamp-1">
                                Masukan Nominal
                            </span>
                            <Input
                                id={1}
                                name={"saldo"}
                                value={selectedNominalItems.harga === "0" ? "" : selectedNominalItems.harga}
                                onChange={(value) => {
                                    const newValue = value === null || value === "" ? "0" : value;

                                    setselectedNominalItems({
                                        ...selectedNominalItems,
                                        harga: newValue
                                    });

                                    setInputSaldo(newValue);
                                    setSelectedPaymentItems([])
                                }}
                                type={'number'}
                                bgcolor={"bg-[#edeeee]"}
                                placeholder={`Minimal Rp.0,-`}
                            />
                            <span className="text-base font-medium line-clamp-1">
                                Nominal
                            </span>
                            <div className="grid flex-1 grid-cols-3 gap-2">
                                {[{ fee: 10000 }, { fee: 20000 }, { fee: 50000 }, { fee: 100000 }, { fee: 150000 }, { fee: 200000 }, { fee: 300000 }].map((item, index) => (
                                    <button
                                        onClick={() => {
                                            const newValue = item.fee === null || item.fee === "" ? "0" : item.fee;

                                            setselectedNominalItems({
                                                ...selectedNominalItems,
                                                harga: newValue
                                            });

                                            setInputSaldo(newValue);
                                            setSelectedPaymentItems([])

                                        }} key={index} className={`flex flex-col flex-1 ${selectedNominalItems.harga === item.fee ? ' bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] text-darkColor' : 'bg-[#DFF9FF] text-[#22BDE2]'} p-3 rounded-md shadow-inner`}>
                                        <span className="sm:text-base text-sm font-medium ">
                                            {formatRupiah(item.fee)}
                                        </span>
                                    </button>
                                ))}
                            </div>

                        </div>
                    </div>
                    {selectedPaymentItems.length === 0 ? null :
                        <div className="p-4 shadow-inner sm:flex-row gap-2 flex-col flex justify-between rounded-lg bg-cardLight dark:bg-cardDark ">
                            <div className="flex flex-col justify-end gap-2 flex-1">
                                {hargaFix.logo &&
                                    <img
                                        alt="pembayaran"
                                        className="h-7 object-contain w-16 "
                                        src={hargaFix.logo} />
                                }
                                <span className=" text-xl font-bold line-clamp-1 ">
                                    {formatRupiah(hargaFix.harga)}
                                </span>
                            </div>
                            <div className="flex flex-col gap-2">
                                <Button
                                    initialValue="Topup Saldo"
                                    type="fill"
                                    color={'#ffffff'}
                                    iconLeft={<MoneyIcon />}
                                    className="bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] text-darkColor"
                                    onClick={() => {
                                        const phoneRegex = /^\+62\d{8,17}$/;
                                        if (selectedPaymentItems.pake_rek === "1") {
                                            if (selectedrekPayment[0].nama === "Saldo") {
                                                if (selectedrekPayment[0].value.length < 6) {
                                                    toast.error(`PIN pada Pembayaran ${selectedrekPayment[0].nama} tidak valid. Mohon periksa masukan Anda.`, {
                                                        position: toast.POSITION.TOP_RIGHT,
                                                    });
                                                } else {
                                                    getOrderConfirm();
                                                }
                                            } else {
                                                if (!phoneRegex.test(selectedrekPayment[0].value)) {
                                                    toast.error(`Nomor WhatsApp pada Pembayaran ${selectedrekPayment[0].nama} tidak valid. Mohon periksa masukan Anda.`, {
                                                        position: toast.POSITION.TOP_RIGHT,
                                                    });
                                                } else {
                                                    getOrderConfirm();
                                                }
                                            }
                                        } else {
                                            getOrderConfirm();
                                        }
                                    }}
                                />
                                <div className="flex flex-row gap-2 items-center">
                                    <DefenderIcon />
                                    <span className=" text-xs flex-1">Pembayaran anda terjamin aman </span>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <div className="flex flex-col rounded-lg shadow-inner bg-cardLight dark:bg-cardDark sm:basis-5/12" >
                    <div className="flex flex-row items-center gap-1 rounded-md  bg-[#22BDE2] text-darkColor">
                        <div className=' items-center justify-center flex rounded-md bg-gradient-to-r from-[#22BDE2] to-[#FC00FF]  p-3 h-12 w-12 '>
                            <span className="font-bold">
                                2
                            </span>
                        </div>
                        <span className="text-base px-3 font-medium line-clamp-1">
                            Pilih Metode Pembayaran
                        </span>
                    </div>
                    <div className="flex flex-col justify-between rounded-b-lg gap-2 py-3 ">
                        <span className="text-base px-3 font-medium line-clamp-1">
                            Pilih Metode Pembayaran
                        </span>
                        <PaymentMethodComponent
                            paymentData={paymentData}
                            paymentLoading={paymentLoading}
                            selectedNominalItems={selectedNominalItems}
                            selectedPaymentItems={selectedPaymentItems}
                            selectedrekPayment={selectedrekPayment}
                            setSelectedPaymentItems={setSelectedPaymentItems}
                            setselectedrekPayment={setselectedrekPayment}
                            hargaFix={setHargaFix}
                        />
                    </div>
                </div>
            </div>


            <ModalOrderConfirm
                active={isModalOrderConfirm}
                onClose={toggleModalOrderConfirm}
                productData={inputSaldo}
                orderConfirm={orderConfirm}
                setOrderFix={setOrderFix}
                type={'giftcard'}
            />

            <ModalBox active={isModalSuccessTransaction} onClose={toggleModalSuccessTransaction}>
                <div className="flex flex-col gap-3">
                    <div className="flex items-center justify-center">
                        <img className="flex w-[50%]"
                            src={require("../../assets/images/successTransaction.gif")}
                            alt="promo not found"
                        />
                    </div>
                    <div className="flex flex-col">
                        <span
                            className={`text-[#333333] text-lg font-semibold `}
                        >
                            Transaksi Berhasil!
                        </span>
                        <span
                            className={`text-[#333333] text-sm `}
                        >
                            Periksa halaman transaksi anda untuk info lebih lanjut
                        </span>
                    </div>
                    <div className="flex flex-row gap-2">
                        {/* <Button
              initialValue="Oke"
              type="fill"
              color="bg-[#CCCCCC] w-full "
              onClick={() => {
                toggleModalSuccessTransaction();
                handleClickLoading('/')
              }}
            /> */}
                        <Button
                            initialValue="Lihat Invoice"
                            type="fill"
                            className="bg-[#22BDE2] text-darkColor w-full"
                            onClick={() => {
                                toggleModalSuccessTransaction();
                                handleClickLoading('/invoice/' + invoice)
                            }}
                        />
                    </div>
                </div>
            </ModalBox>

            <ModalBox active={confirmModal} onClose={() => {
                setconfirmModal(false)
            }}>
                <div className="flex flex-col gap-3">
                    <div className="flex flex-row justify-center">
                        <span className=" text-center text-darkColor">Apakah Anda Ingin Redeem Gift Card ?</span>
                    </div>
                    <div className="flex flex-row flex-1 gap-3">
                        <Button
                            initialValue="Tidak"
                            type="fill"
                            color={"#ffffff"}
                            className=" bg-lightColor text-lightColor flex-1"
                            onClick={() => {
                                setconfirmModal(false)
                            }}
                        />
                        <Button
                            initialValue="Iya"
                            type="fill"
                            color={"#ffffff"}
                            className=" bg-[#132239] text-darkColor flex-1"
                            onClick={() => {
                                changeReedemVoucher()
                            }}
                        />
                    </div>
                </div>
            </ModalBox>
        </div>
    );
}

export default GiftCard;
